export default __webpack_public_path__ + "static/media/appStore.5fa8a709.svg";